import { render, staticRenderFns } from "./stamp-right.vue?vue&type=template&id=7775ecaa&"
import script from "./stamp-right.vue?vue&type=script&lang=js&"
export * from "./stamp-right.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports